/**
 * Neyra service categories — 2-level taxonomy.
 * Used by Create Service category picker.
 */
export const SERVICE_CATEGORIES = [
    {
        id: "beauty",
        label: "Beauty & Personal Care",
        subs: [
            "Hair Styling",
            "Makeup",
            "Skincare",
            "Nails",
            "Spa & Massage",
            "Barber Services",
            "Personal Styling",
        ],
    },
    {
        id: "fashion",
        label: "Fashion & Tailoring",
        subs: [
            "Custom Tailoring",
            "Alterations",
            "Fashion Design",
            "Aso Ebi / Event Wear",
            "Shoe Making & Repairs",
            "Bag Making",
        ],
    },
    {
        id: "home",
        label: "Home Repair & Skilled Trades",
        subs: [
            "Plumbing",
            "Electrical",
            "Carpentry",
            "Painting",
            "Tiling & Flooring",
            "Roofing",
            "Welding",
            "POP Ceiling / Interior Work",
        ],
    },
    {
        id: "cleaning",
        label: "Cleaning & Domestic Services",
        subs: [
            "Home Cleaning",
            "Office Cleaning",
            "Laundry & Dry Cleaning",
            "Babysitting / Nanny",
            "Housekeeping",
            "Elderly Care",
        ],
    },
    {
        id: "logistics",
        label: "Logistics & Delivery",
        subs: [
            "Local Delivery",
            "Inter-State Delivery",
            "International Shipping",
            "Errand Services",
            "Moving & Relocation",
            "Courier Services",
        ],
    },
    {
        id: "tech",
        label: "Tech & Digital Services",
        subs: [
            "Phone Repair",
            "Laptop Repair",
            "Software Installation",
            "Web Development",
            "App Development",
            "Graphics Design",
            "Digital Marketing",
        ],
    },
    {
        id: "events",
        label: "Events & Entertainment",
        subs: [
            "Event Planning",
            "MC / Host",
            "DJs / Bands",
            "Photography / Videography",
            "Decoration & Rentals",
            "Catering",
        ],
    },
    {
        id: "automotive",
        label: "Automotive Services",
        subs: [
            "Car Repair",
            "Car Wash",
            "Car Rental",
            "Towing",
            "Battery Jumpstart",
            "Servicing",
        ],
    },
    {
        id: "health",
        label: "Health & Wellness",
        subs: [
            "Fitness Training",
            "Yoga & Meditation",
            "Nutrition",
            "Home Nursing",
            "Physiotherapy",
            "Mental Health",
        ],
    },
    {
        id: "business",
        label: "Business & Professional",
        subs: [
            "Legal Services",
            "Accounting",
            "Business Registration",
            "Consulting",
            "CV Writing",
            "Virtual Assistant",
        ],
    },
    {
        id: "security",
        label: "Security Services",
        subs: [
            "Security Guards",
            "CCTV Installation",
            "Access Control",
            "Home Security Setup",
        ],
    },
    {
        id: "education",
        label: "Education & Training",
        subs: [
            "Home Tutoring",
            "Online Classes",
            "Skill Acquisition",
            "Language Training",
            "Exam Prep",
        ],
    },
    {
        id: "other",
        label: "Other",
        subs: [],
    },
];

export const findCategory = (categoryLabel) =>
    SERVICE_CATEGORIES.find((c) => c.label === categoryLabel) || null;
